module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bPyBw"))).then(() => parcelRequire('1iHdE'));